var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirbnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-7",
    transform: "translate(-544.000000, -1414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airbnb",
    transform: "translate(544.000000, 1414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "testimonial",
    d: "M63.3,51.5c-0.3-0.6-0.5-1.3-0.8-1.8c-0.4-0.9-0.8-1.8-1.2-2.6l-0.1-0.1c-3.5-7.5-7.2-15.1-11.2-22.6 L50,24.2c-0.4-0.8-0.8-1.6-1.2-2.4c-0.5-0.9-1-1.9-1.8-2.8c-1.6-2-3.9-3.1-6.4-3.1c-2.5,0-4.8,1.1-6.5,3 c-0.8,0.9-1.3,1.9-1.8,2.8c-0.4,0.8-0.8,1.6-1.2,2.4l-0.2,0.3C27,31.9,23.2,39.5,19.7,47l-0.1,0.1c-0.4,0.8-0.8,1.7-1.2,2.6 c-0.3,0.5-0.5,1.2-0.8,1.8c-0.7,1.9-0.9,3.6-0.6,5.4c0.6,3.8,3.1,6.9,6.6,8.3c1.3,0.6,2.7,0.8,4.1,0.8c0.4,0,0.9-0.1,1.3-0.1 c1.7-0.2,3.4-0.8,5.1-1.7c2.1-1.2,4-2.8,6.3-5.2c2.2,2.4,4.3,4.1,6.3,5.2c1.7,1,3.4,1.5,5.1,1.7c0.4,0,0.9,0.1,1.3,0.1 c1.4,0,2.8-0.3,4.1-0.8c3.5-1.4,6-4.6,6.6-8.3C64.2,55.1,64,53.4,63.3,51.5z M40.5,54.1c-2.7-3.4-4.5-6.6-5.1-9.3 c-0.3-1.2-0.3-2.2-0.2-3.1c0.1-0.8,0.4-1.5,0.8-2.1c1-1.4,2.6-2.2,4.5-2.2c1.9,0,3.5,0.8,4.5,2.2c0.4,0.6,0.7,1.3,0.8,2.1 c0.2,0.9,0.1,2-0.2,3.1C45,47.5,43.2,50.7,40.5,54.1z M60.7,56.5c-0.4,2.6-2.1,4.9-4.6,5.9c-1.2,0.5-2.5,0.7-3.8,0.5 c-1.3-0.1-2.5-0.5-3.8-1.3c-1.8-1-3.6-2.6-5.8-4.9c3.3-4.1,5.4-7.8,6.1-11.1c0.4-1.6,0.4-3,0.3-4.3c-0.2-1.3-0.7-2.4-1.4-3.4 c-1.6-2.3-4.2-3.6-7.1-3.6c-2.9,0-5.6,1.4-7.1,3.6c-0.7,1-1.2,2.2-1.4,3.4c-0.2,1.3-0.2,2.8,0.3,4.3c0.8,3.3,2.8,7.1,6.1,11.1 c-2.1,2.3-3.9,3.9-5.8,4.9c-1.3,0.8-2.6,1.2-3.8,1.3c-1.4,0.1-2.7-0.1-3.8-0.5c-2.5-1-4.3-3.3-4.6-5.9c-0.2-1.3-0.1-2.5,0.5-3.9 c0.2-0.5,0.4-1,0.7-1.6c0.4-0.8,0.8-1.7,1.2-2.5l0.1-0.1C26.1,41,29.9,33.4,33.8,26l0.2-0.3c0.4-0.8,0.8-1.6,1.2-2.3 c0.4-0.8,0.9-1.6,1.4-2.2c1.1-1.2,2.5-1.9,4.1-1.9c1.6,0,3,0.7,4.1,1.9c0.6,0.6,1,1.4,1.4,2.2c0.4,0.8,0.8,1.6,1.2,2.3l0.2,0.3 C51.3,33.4,55,41,58.5,48.5v0c0.4,0.8,0.8,1.7,1.2,2.5c0.3,0.6,0.5,1.1,0.7,1.6C60.8,53.9,60.9,55.2,60.7,56.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbnb);
export default __webpack_public_path__ + "static/media/airbnb.3f202facc56a972d9c5c3d8c1f388e9f.svg";
export { ForwardRef as ReactComponent };